import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

@Injectable()
export class InvoiceService {
  constructor(private readonly rest: RestService) {}

  getInvoices(params: any = null): Promise<any> {
    const queryParams = objectToQueryString(params);

    return this.rest.get(`${environment.apiUrl}/api/core/invoice${queryParams}`);
  }

  getInvoiceById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/invoice/${id}`);
  }

  syncInvoice(id: number): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/invoice/${id}/!sync`, {});
  }
}
